type TSendResizeMessageOptions = {
  type: string;
  meta?: Record<string, unknown>;
  payload?: {
    frame?: {
      style?: Partial<CSSStyleDeclaration>;
    };
  };
};

function sendResizeMessage({ type, meta, payload }: TSendResizeMessageOptions): void {
  const message = {
    type,
    meta,
    payload,
  };
  window.parent.postMessage(message, '*');
}

function getInstanceFromUrl(): string | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }

  return new URLSearchParams(window.location.search).get('instance') || undefined;
}

export { sendResizeMessage, getInstanceFromUrl };
